export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiClientId: process.env.REACT_APP_API_CLIENT_ID,
  apiSecret: process.env.REACT_APP_API_SECRET,
  password_grantType: process.env.REACT_APP_PASSWORD_GRANT_TYPE,
  refreshToken_grantType: process.env.REACT_APP_REFRESH_TOKEN_GRANT_TYPE,
  gtmId: process.env.REACT_APP_GTM_ID,
};
